module.exports = __webpack_public_path__ + "media/apps/google-play-fr-303fa03f.png";